import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CellType } from './index.types';

export const StyledRow = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 4px 0px;
`;

export const StyledTable = styled(Box)`
  width: 100%;
`;

const CELL_MARGIN = 20; // px

export const StyledCell = styled(Box)<{
  w: string | number;
  type: CellType;
  depth?: number;
}>`
  width: calc(
    ${(props) => props.w} - ${(props) => CELL_MARGIN * (props.depth || 0)}px
  );
  background-color: ${(props) => {
    if (props.type === 'header') return '#38414f';
    return '#f2f2f2';
  }};
  border-left: 5px solid
    ${(props) => {
      if (props.type === 'unit') return '#91D165';
      return '#fff';
    }};
  color: ${(props) => {
    if (props.type === 'header') return '#fff';
    return '#38414F';
  }};
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.45px;
  padding: 15px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${(props) => (props.depth || 0) * CELL_MARGIN}px;
`;

// Country group header cell (top row of the two-row header, C12 Goal 1).
// Same dark-header palette family as StyledCell's `#38414f`, one shade
// lighter (`#5a6472`) so the two stacked header rows read as related but
// distinct bands -- mirrors `table.sat th.grp2` in the mockup
// (specs/001-raben-country-masteradmin/reference/raben-side-by-side.html).
export const StyledGroupHeaderCell = styled(Box)<{ w: string | number }>`
  width: ${(props) => props.w};
  background-color: #5a6472;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  padding: 15px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledProductCellContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 10px;
  font-family: Poppins;
`;

export const IconHolder = styled(Box)`
  width: 24px;
  height: 24px;
`;
